import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
} from "@mui/material";

/**
 * Dialog for creating a new user account.
 */
export default function CreateUserDialog({
  open,
  onClose,
  formData = { name: "", email: "" },
  onFormDataChange,
  onCreate,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create User Account</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={1.5}>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Name"
              value={formData.name || ""}
              onChange={(e) => onFormDataChange({ ...formData, name: e.target.value })}
              margin="dense"
              size="small"
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              required
              value={formData.email || ""}
              onChange={(e) => onFormDataChange({ ...formData, email: e.target.value })}
              margin="dense"
              size="small"
              helperText="Email is required"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onCreate}
          variant="contained"
          disabled={!formData.email || !formData.email.trim()}
        >
          Create User
        </Button>
      </DialogActions>
    </Dialog>
  );
}
